<template>
    <div :class="(index<=2 ? 'col-md-4':'col-md-3')">
        <div class="single-classification" :class="(featured_orders.hasOwnProperty(classification.order) ? featured_orders[classification.order]+' featured-classification' : '')">
            <div class="classification-header">
                <div class="throphy-image" v-if="throphys.hasOwnProperty(classification.order)">
                    <img :src="getImageUrl('assets/img/'+throphys[classification.order])">
                </div>

                <div class="classification-title text-white text-left">
                    {{classification.classification.name}}
                </div>

                <div class="classification-prize text-left">
                    {{classification.prize}}
                </div>

                <div class="classification-note text-left">
                    {{classification.note}}
                </div>
            </div>
            <div class="classification-body">
                <div class="classification-team" v-for="team in classification.teams">
                    <div class="team-logo">
                      <img :src="$urlOrDefault(team.logo_picture,'logo')">
                    </div>
                    <div class="team-name">
                        {{ team.name }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Funcs from "@/functions";

    export default {
        name: "Classification",
        props: {
            i: Number,
            classif: Object
        },
        data: function(){
            return {
                index: null,
                classification:null,
                featured_orders:{0:'gold-bg',1:'silver-bg',2:'bronze-bg'},
                throphys:{0:'trophy_gold.png',1:'trophy_silver.png',2:'trophy_bronze.png'}
            }
        },
        created: function(){
            this.index=this.$props.i;
            this.classification=this.$props.classif;
        },
        methods: {
          getImageUrl: function(url){
            return Funcs.getImageUrl(url);
          },
        }
    }
</script>

<style scoped>

    .single-classification.featured-classification, .single-classification.featured-classification>.classification-body {
        border:none;
    }

    .single-classification .classification-header {
        border-radius: 5px 5px 0px 0px;
        padding-left: 30px;
        padding-right: 30px;
        padding-top: 30px;
        padding-bottom: 30px;
        height: 160px;
        border: 1px solid rgba(120, 131, 138, 0.31);
        box-sizing: border-box;
        border-bottom: none;
        position: relative;
    }

    .featured-classification .classification-header {
        height: 160px;
    }

    .featured-classification.gold-bg > .classification-header
    {
        background: linear-gradient(133.99deg, rgba(204, 166, 83, 0.81) 64.66%, rgba(146, 107, 24, 0.81) 166.16%);
    }

    .featured-classification.silver-bg > .classification-header {
        background: linear-gradient(133.99deg, rgba(141, 141, 141, 0.81) 64.66%, rgba(91, 91, 91, 0) 166.16%);
    }

    .featured-classification.bronze-bg > .classification-header {
        background: linear-gradient(133.99deg, rgba(197, 126, 74, 0.82) 64.66%, rgba(197, 126, 74, 0) 166.16%);
    }

    .single-classification .classification-header > .classification-title {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
        height: 46px;
        line-height: 46px;
    }

    .single-classification .classification-header > .classification-prize {
        color: rgba(255,255,255,0.5);
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        height: 30px;
        line-height: 30px;
    }

    .single-classification .classification-header > .classification-note {
        font-weight: 500;
        font-size: 15px;
        color: rgba(255,255,255,0.5);
    }

    .single-classification .classification-body {
        border-radius: 0px 0px 5px 5px;
        border: 1px solid rgba(120, 131, 138, 0.31);
        box-sizing: border-box;
        position: relative;
    }

    .featured-classification .classification-body {
        background-color: rgba(40, 51, 58, 0.81);
    }

    .single-classification.featured-classification .classification-body > .classification-team {
        height:75px;
    }

    .single-classification .classification-header > .throphy-image {
        position: absolute;
        width: 100px;
        height: 100px;
        right: 20px;
        top: -30px;
        transform: rotate(6.44deg);
    }

    .single-classification .classification-body > .classification-team {
        width: 100%;
        height: 60px;
    }

    .single-classification .classification-body > .classification-team > .team-logo {
        width: 20%;
        height:100%;
        text-align: center;
        vertical-align: middle;
        float: left;
        line-height: 60px;
    }

    .single-classification .classification-body > .classification-team > .team-logo > img {
        max-height: 65%;
    }

    .single-classification.featured-classification .classification-body > .classification-team > .team-logo > img {
        max-height: 80%;
    }

    .single-classification .classification-body > .classification-team > .team-name {
        width:75%;
        margin-left: 5%;
        height:100%;
        text-align: left;
        color:#FFF;
        float: left;
        line-height: 60px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
    }

    .featured-classification .classification-body > .classification-team > .team-name {
        line-height: 75px;
    }
    .featured-classification .classification-body > .classification-team > .team-logo {
        line-height: 75px;
    }
</style>